import React from 'react';
import { whatWeDoItems } from '../data/mock';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const WhatWeDo = () => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  return (
    <section id="what-we-do" className="relative py-32 lg:py-40">
      {/* Background accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left - Header */}
          <div ref={ref} className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <p className="text-purple-400 text-sm font-medium tracking-widest uppercase mb-4">The Problem</p>
            <h2 className="font-display text-4xl lg:text-5xl text-white mb-6">
              Most companies don't have a technology problem—
            </h2>
            <p className="font-display text-4xl lg:text-5xl text-gradient mb-8">
              they have a systems problem.
            </p>
            <p className="text-white/50 text-lg leading-relaxed">
              Architecture first. Automation second. AI last.
            </p>
          </div>

          {/* Right - Cards */}
          <div className="space-y-4">
            {whatWeDoItems.map((item, index) => (
              <WhatWeDoCard key={item.id} item={item} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const WhatWeDoCard = ({ item, index }) => {
  const [ref, isVisible] = useScrollAnimation(0.1);
  
  return (
    <div
      ref={ref}
      className={`group p-6 border border-white/5 bg-white/[0.02] hover:bg-white/[0.04] hover:border-purple-500/30 transition-all duration-500 cursor-default ${
        isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
      }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <div className="flex items-start gap-6">
        <span className="text-purple-500/50 text-sm font-mono">0{index + 1}</span>
        <div>
          <h3 className="text-xl text-white mb-1">
            <span className="font-semibold">{item.title}</span>
            <span className="text-white/40 font-normal"> {item.subtitle}</span>
          </h3>
          <p className="text-white/40 text-sm">{item.description}</p>
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
